<template>
  <button
    :type="type"
    :disabled="disabled || loading"
    :class="classes"
    v-bind="$attrs">
    <AppSpinner
      v-if="loading"
      size="sm"
      class="mr-1.5" />
    <slot />
  </button>
</template>

<script>
import AppSpinner from './AppSpinner.vue'

// azul, blanco, transparente, rojo, verde
const VARIANTS = {
  primary: 'border border-transparent bg-brand text-white font-semibold hover:bg-brandStrong focus-visible:ring-brand/40 disabled:opacity-50',
  secondary: 'border border-line bg-surface text-ink hover:bg-surfaceAlt focus-visible:ring-brand/30 disabled:opacity-50',
  ghost: 'border border-transparent bg-transparent text-muted hover:bg-surfaceAlt hover:text-ink focus-visible:ring-brand/30 disabled:opacity-40',
  danger: 'border border-transparent bg-danger text-white hover:bg-red-700 focus-visible:ring-danger/40 disabled:opacity-50',
  dangerOutline:
    'border border-red-200 text-danger bg-surface hover:bg-danger hover:text-white hover:border-danger focus-visible:ring-danger/30 disabled:opacity-50',
  success: 'border border-transparent bg-success text-white hover:bg-green-700 focus-visible:ring-success/40 disabled:opacity-50',
  warning: 'border border-transparent bg-warn text-white hover:bg-amber-700 focus-visible:ring-warn/40 disabled:opacity-50',
  warningOutline:
    'border border-warn/30 text-warn bg-surface hover:bg-warn hover:text-white hover:border-warn focus-visible:ring-warn/30 disabled:opacity-50',
  info: 'border border-transparent bg-info text-white hover:bg-blue-700 focus-visible:ring-info/40 disabled:opacity-50',
  infoOutline:
    'border border-info/30 text-info bg-surface hover:bg-info hover:text-white hover:border-info focus-visible:ring-info/30 disabled:opacity-50',
}

const SIZES = {
  sm: 'text-xs px-2.5 py-1.5 gap-1',
  md: 'text-sm px-3.5 py-2 gap-1.5',
  lg: 'text-base px-5 py-2.5 gap-2',
}

export default {
  name: 'AppButton',
  components: { AppSpinner },
  inheritAttrs: false,
  props: {
    variant: { type: String, default: 'primary' },
    size: { type: String, default: 'md' },
    type: { type: String, default: 'button' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    pill: { type: Boolean, default: false },
  },
  computed: {
    classes() {
      return [
        'inline-flex items-center justify-center font-medium transition-colors',
        'focus-visible:outline-none focus-visible:ring-2',
        this.pill ? 'rounded-full' : 'rounded-lg',
        VARIANTS[this.variant] ?? VARIANTS.primary,
        SIZES[this.size] ?? SIZES.md,
        { 'cursor-not-allowed': this.disabled || this.loading },
      ]
    },
  },
}
</script>
